var _path, _path2, _path3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIconFa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.251,
    height: 18.251,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C18.9 2 7.8 10.3 3.7 22h56.6C56.2 10.3 45.1 2 32 2z",
    fill: "#83bf4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62c13.1 0 24.2-8.3 28.3-20H3.7C7.8 53.7 18.9 62 32 62z",
    fill: "#ed4c5c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 22C2.6 25.1 2 28.5 2 32s.6 6.9 1.7 10h56.6c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.7z",
    fill: "#f9f9f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4 44.3l-.3.6h.3v-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 44.9l-.3-.6v.6h.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 18.8h-.5c-.1.1-.2.2-.2.3h.7v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 21v-.3h-1v-.6h1.5v.9h2.2v-2.3H8v1.9h-.6v-1.9h-.3v1.9h-.6v-1.9h-.3v1H4.6c-.1.2-.2.5-.3.7v.6h1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 44.9h-.7c0 .1.1.2.2.3h.6l-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 44.3h1.5v.9h2.2v-2.3H8v1.9h-.6v-1.9h-.3v1.9h-.6v-1.9h-.3v1H4.5c0 .2.1.3.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 43H4.1c0 .1.1.2.1.3h1.4V43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 21H15v-.3h-1v-.6h1.5v.9h2.2v-2.3h-.3v2h-.6v-2h-.4v2h-.6v-2h-.3v1h-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-1.3h-1.3v.4h1v.6h-1.5v-1H9v1.4h.3v-1h1.5v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 18.8H15v.3H8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 44.3h1v.6h-1.5v-1H9v1.4h.3v-1h1.5v.9H13v-1.3h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 43H15v.3H8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 44.9h-.6v-2h-.4v2h-.6v-2h-.3v1h-1.9v1.3H15v-.3h-1v-.6h1.5v.9h2.2v-2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21h1.3v-.3h-1v-.6h1.5v.9H27v-2.3h-.3v2h-.6v-2h-.3v2h-.6v-2h-.4v1H23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 21v-1.3H21v.4h1v.6h-1.5v-1h-2.2v1.4h.3v-1h1.6v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 18.8h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 44.9h-.6v-2h-.3v2h-.6v-2h-.4v1H23v1.3h1.3v-.3h-1v-.6h1.5v.9H27v-2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 43h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 44.3h1v.6h-1.5v-1h-2.2v1.4h.3v-1h1.6v.9h2.2v-1.3H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 21v-1.3h-1.3v.4h1v.6h-1.6v-1h-2.2v1.4h.4v-1h1.5v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 18.8h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 21h1.3v-.3h-1v-.6h1.6v.9h2.2v-2.3H36v2h-.6v-2h-.3v2h-.6v-2h-.3v1h-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 43h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 44.3h1v.6h-1.6v-1h-2.2v1.4h.4v-1h1.5v.9h2.2v-1.3h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 44.9h-.6v-2h-.3v2h-.6v-2h-.3v1h-1.9v1.3h1.3v-.3h-1v-.6h1.6v.9h2.2v-2.3H36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 18.8H43v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 21H43v-.3h-1v-.6h1.5v.9h2.2v-2.3h-.3v2h-.6v-2h-.4v2h-.6v-2h-.3v1h-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 21v-1.3h-1.3v.4h1v.6h-1.5v-1H37v1.4h.3v-1h1.5v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9 43H43v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4 44.9h-.6v-2h-.4v2h-.6v-2h-.3v1h-1.9v1.3H43v-.3h-1v-.6h1.5v.9h2.2v-2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 44.3h1v.6h-1.5v-1H37v1.4h.3v-1h1.5v.9H41v-1.3h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 21v-1.3H49v.4h1v.6h-1.5v-1h-2.2v1.4h.3v-1h1.6v.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 18.8h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 21h1.3v-.3h-1v-.6h1.5v.9H55v-2.3h-.3v2h-.6v-2h-.3v2h-.6v-2h-.4v1H51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 44.3h1v.6h-1.5v-1h-2.2v1.4h.3v-1h1.6v.9h2.2v-1.3H49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 43h6.1v.3h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7 44.9h-.6v-2h-.3v2h-.6v-2h-.4v1H51v1.3h1.3v-.3h-1v-.6h1.5v.9H55v-2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6 19.1h3.5c-.1-.1-.1-.2-.2-.3h-3.4c.1 0 .1.3.1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4 20.1h1v.6h-1.5v-.9h-2.2v1.3h.3v-1h1.5v.9h2.2v-.5c-.1-.2-.2-.5-.3-.7h-1v.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 20.7h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 44.9h.5v.3h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6 43v.3h4.2c0-.1.1-.2.1-.3h-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4 44.3h1c.1-.1.1-.2.2-.4h-1.2v.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 44.9V44h-2.2v1.3h.4v-1h1.5v.9h1.4c.1-.1.1-.2.2-.3h-1.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 33.9c.9-2.6 0-5.5-2-7.3c2.3 3.4 1.4 7.9-1.8 10.3l.2-5.6v-4.4c-.4-.2-.7-.4-.9-.7c-.2.3-.5.6-.9.7v4.4l.2 5.6c-3.3-2.4-4.1-6.9-1.8-10.3c-2.1 1.8-2.9 4.7-2 7.3c.6 1.8 1.8 3.1 3.3 3.9c-.9.3-1.9.5-2.9.5c1.2.4 2.4.4 3.5.2v.2l.6.8l.6-.8v-.2c1.1.2 2.3.2 3.5-.2c-1 0-2-.1-2.9-.5c1.5-.8 2.7-2.2 3.3-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 29.1c-.8-1.3-2.1-2.3-3.6-2.7c3.3 2.5 4 7.2 1.5 10.5c2.8-1.5 3.7-5 2.1-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 26.4c-1.5.4-2.8 1.3-3.6 2.7c-1.6 2.7-.6 6.2 2.1 7.8c-2.4-3.3-1.8-8 1.5-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26c.5.3 1.2.2 1.5-.3c.3.5 1 .6 1.5.3c.4-.3.6-.8.4-1.3c-.1.6-.6.9-1.2.8c-.3-.1-.5-.2-.7-.5c-.1.3-.4.4-.7.5c-.6.1-1.1-.3-1.2-.8c-.2.5 0 1 .4 1.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconFa);
export default __webpack_public_path__ + "static/media/language-icon-fa.24b76ac45bb5b9908986bbefc7deb65c.svg";
export { ForwardRef as ReactComponent };